/**
* DevExpress Analytics (accessibility\_rightPanelKeyboardHelper.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var _controlElementBase_1 = require("./_controlElementBase");
var _keyboardHelperBase_1 = require("./_keyboardHelperBase");
var RightPanelKeyboardHelper = (function (_super) {
    __extends(RightPanelKeyboardHelper, _super);
    function RightPanelKeyboardHelper(_tabPanel) {
        var _this = _super.call(this) || this;
        _this._tabPanel = _tabPanel;
        _this.controlElementClassName = 'dx-accessibility-rightpanel-button';
        return _this;
    }
    RightPanelKeyboardHelper.prototype.bindHandler = function (el) {
        var _this = this;
        _super.prototype.bindHandler.call(this, el);
        this._disposables.push(ko.computed(function () {
            _this._tabPanel.tabs.forEach(function (tab) { ko.unwrap(tab.visible); });
            _this.initialize();
        }).extend(({ rateLimit: { timeout: 1, method: 'notifyWhenChangesStop' } })));
    };
    RightPanelKeyboardHelper.prototype.initialize = function () {
        _super.prototype.initialize.call(this);
        this.setTabIndexes(0);
    };
    RightPanelKeyboardHelper.prototype.createControlElement = function (element, index) {
        if (element.classList.contains('dxrd-right-panel-collapse'))
            return new _controlElementBase_1.AccessibilityControlElementBase(element);
        if (ko.unwrap(this._tabPanel.tabs[index - 1].visible))
            return new _controlElementBase_1.AccessibilityControlElementBase(element);
    };
    RightPanelKeyboardHelper.prototype.itemHandleDownArrowKey = function (e, index) {
        this.setFocusToNext(index, true);
        return true;
    };
    RightPanelKeyboardHelper.prototype.itemHandleUpArrowKey = function (e, index) {
        this.setFocusToPrevious(index, true);
        return true;
    };
    return RightPanelKeyboardHelper;
}(_keyboardHelperBase_1.AccessibilityKeyboardHelperBase));
exports.RightPanelKeyboardHelper = RightPanelKeyboardHelper;
